import { BaseSyntheticEvent, useCallback, useEffect, useRef, useState } from 'react';
import ReactModal from 'react-modal';
// import Spinner from '../../Spinner/Spinner';
import {ReactComponent as DeleteIcon} from '../../../images/nde-icon-delete.svg';
import './ExportModal.scss';
// import ga4 from '../../../shared/analyticsEvents';
import { ExportModalProps } from '../models';
import { useSelector } from 'react-redux';
import { selectControls } from '../../../redux/controls';
import {ReactComponent as ExcelIcon} from '../../../images/NDE_icon_formats_xls.svg';
import {ReactComponent as PDFIcon} from '../../../images/NDE_icon_formats_pdf.svg';
import {ReactComponent as WordIcon} from '../../../images/NDE_icon_formats_doc.svg';
import {ReactComponent as HtmlIcon} from '../../../images/NDE_icon_formats_html.svg';
import React from 'react';
import { ExportFormat } from '../../../shared';


export const ExportModal = ({open, onClose, disableExcel}: ExportModalProps) : JSX.Element => {
  // const [isExporting, setIsExporting] = useState(false);
  const controls = useSelector(selectControls);

  // to be moved to db
  const contentLabel = 'Export Report';
  const title = 'Export Report';
  const ExpExcel = 'XLS' as ExportFormat;
  const ExpPDF = 'PDF' as ExportFormat;
  const ExpWord = 'DOC' as ExportFormat;
  const ExpHtml = 'HTML' as ExportFormat;
  const [selectedExport, setSelectedExport] = useState<string>(ExpExcel);
  const exportOptions = [ExpExcel, ExpPDF, ExpWord, ExpHtml];
  const exportImages = [ExcelIcon, PDFIcon, WordIcon, HtmlIcon];
  const closeBtnRef = useRef<HTMLButtonElement>(null);

  ReactModal.setAppElement('#root');

  const onCancel = useCallback(() => {
    onClose(false, '');
  }, [onClose]);

  const onClickFormat = (e: BaseSyntheticEvent, option: string) => {
    e.preventDefault();
    setSelectedExport(option);
  };

  function onOk(): void {
    onClose(true, selectedExport);
  }

  useEffect(() => {
    if (!open) return;
    setSelectedExport(ExpExcel);
    closeBtnRef.current?.focus();
  }, [open, closeBtnRef]);

  useEffect(() => {
    if (disableExcel && selectedExport === ExpExcel) setSelectedExport(ExpPDF);
  }, [disableExcel, selectedExport]);

  return (
    <>
      {
        open &&
        <ReactModal
          isOpen={open}
          className="nqt-modal nqt-modal-export overflow-hidden"
          // onAfterOpen={() => onAfterOpenCallback(winType, cancelEl, okEl)}
          overlayClassName="nqt-modal-overlay"
          shouldFocusAfterRender={true}
          contentLabel={contentLabel}
        >
          <div className="nqt-modal--header-group">
            <header className='nqt-modal--title'>{title}</header>
            <button className='nqt-modal--close-button'
              ref={closeBtnRef}
              type='button'
              onClick={() => onCancel()}>
              <DeleteIcon/>
              <span className="visually-hidden">{controls?.ModalClose?.controlText}</span>
            </button>
          </div>
          <div className="nqt-modal-border">
            <section className="nqt-acc-modal--content nqt-modal-export-section">
              <div className="d-flex flex-row justify-content-center align-items-center">
                { exportOptions.map((option, index) => (
                  <button key={option} className="form-check col text-center"
                    id={option}
                    disabled={option === ExpExcel && disableExcel}
                    role='radio'
                    tabIndex={0}
                    autoFocus={selectedExport === option}
                    onKeyUp={(e) => (e.key === ' ' || e.key === 'Enter') && setSelectedExport(option)}
                  >
                    <div onClick={(e) => onClickFormat(e, option)}><div className='nqt-transparent'><span></span></div>{React.createElement(exportImages[index])}</div>
                    <label className="nqt-input-radio-container">
                      <input className='d-none'
                        type="radio"
                        name="exportSelection"
                        value={option}
                        checked={selectedExport === option}
                        onChange={(e) => onClickFormat(e, option)}
                      />
                      <span className="nqt-input-radio"
                        aria-checked={selectedExport === option}
                        onKeyUp={(e) => (e.key === ' ' || e.key === 'Enter') && onClickFormat(e, option)}
                        role="radio">
                      </span>
                      <span className="nqt-input-radio-label ps-1">{option}</span>
                    </label>
                  </button>
                )
                )}

              </div>
            </section>
          </div>
          <div className="nqt-modal--buttons col-9 offset-3">
            <button className="nqt-button--cancel col-4 offset-3" type='button' onClick={onCancel}>Cancel</button>
            <button className="nqt-button--submit col-4" type="submit" onClick={onOk}>Export</button>
          </div>
        </ReactModal>
      }
    </>
  );
};
